<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_4">To Kendra, Erin, Corey, and Noah.</p>
<p class="block_5"> </p>
<p class="block_2"><i class="calibre1">Memento vivere… don’t let your story wither away inside you. </i><br class="calibre2" id="calibre_pb_1"/>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?41c0200e